import * as React from 'react';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/content/default/content.min.css';
import { Editor } from '@tinymce/tinymce-react';
import * as Glob from '../Globale';
import { Trad } from '.';

interface IHTMLEditorProps {
    Name: string;
    Value: string;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => void;
    CampoWordMassimoUnaTabella?: boolean;
}


export const HTMLEditor: React.FC<IHTMLEditorProps> = (props) => {
    const OnChange = (e: any) => {
        props.OnChange(props.Name, e.target.getContent());
    }

    const OnBlur = (e: any) => {
        if (props.CampoWordMassimoUnaTabella ?? false) {
            if ((e.target.getContent().match(/<table>|<table /g) || []).length > 1) {
                Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.Trad("CampoWordMassimoUnaTabella"));
            }
        }
    }

    return (
        <Editor
            //apiKey="ca62pk2b16us7dp7wd2clnjudb9kcw1zxqun164th657l03a"
            initialValue={props.Value}
            init={{
                language_url: Glob.GetLocale().Lingua == "it" ? "/TinyMCE/it_IT.js" : "",
                language: Glob.GetLocale().Lingua == "it" ? "it_IT" : "en_GB",
                height: 500,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help'
            }}
            onChange={OnChange}
            onBlur={OnBlur}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/HTMLEditor.tsx